import { isBrowser } from './trick';

const getMonitor = () => {
  if (!isBrowser) {
    return;
  }
  return window['monitor'];
};

export const monitorLog = (params: { t: string; [key: string]: any }) => {
  getMonitor()?.log?.()(params);
};
